const pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cng-include src=\"&quot;elements\u002Fpoll\u002Ftemplate.jade&quot;\"\u003E\u003C\u002Fng-include\u003E";;return pug_html;};
module.exports = template;